class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    // this.toggleShippingSwitch();
  }

  connectedCallback() {
    // this.toggleShippingSwitch();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  toggleShippingSwitch() {
    const toggle = this.querySelector('.js-addon-toggle');

    if (!toggle) return;

    const key = toggle.dataset.storageKey || `nx_addon_${toggle.dataset.variantId}`;
    const stored = localStorage.getItem(key);

    if (stored === '1') toggle.checked = true;
    if (stored === '0') toggle.checked = false;

    // 2) Then sync with cart (source of truth)
    //    If cart already has item -> force checked + storage
    //    If cart doesn't have item -> force unchecked + storage
    this.syncToggleWithCart(toggle);


    toggle.addEventListener('change', async () => {
      console.log('switicjign')
      const variantId = Number(toggle.dataset.variantId);
      if (!variantId) return;

      // Save state
      localStorage.setItem(key, toggle.checked ? '1' : '0');

      // Prevent double taps while request runs
      toggle.disabled = true;

      try {
        if (toggle.checked) {
          console.log('innn')
          // Temporary disable selling_plan inputs to prevent interceptors from grabbing them
          const spInputs = document.querySelectorAll('[name="selling_plan"]');
          const backupNames = [];
          spInputs.forEach(el => {
            backupNames.push(el.name);
            el.name = ""; 
          });

          await fetch('/cart/add.js', {
             method: 'POST',
             headers: {
               'Content-Type': 'application/json',
               'Accept': 'application/json'
             },
             body: JSON.stringify({
               id: Number(variantId),
               quantity: 1,
               selling_plan: null
             })
          })
          .then(res => res.json())
          .then(data => {
             console.log('Addon added direct', data);
          })
          .finally(() => {
             // Restore inputs
             spInputs.forEach((el, i) => {
                el.name = backupNames[i];
             });
          });
        } else {
          await this.removeFromCart(variantId);
        }

        // After update, re-sync to confirm final state
        await this.syncToggleWithCart(toggle);
        // OPTIONAL: refresh cart drawer here
        // refreshCartDrawer();
      } catch (e) {
        console.error(e);

        // If request failed, revert UI to cart truth
        await this.syncToggleWithCart(toggle);
        localStorage.setItem(key, toggle.checked ? '1' : '0');
      } finally {
        toggle.disabled = false;
      }
    });


  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  async getCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Failed to fetch cart');
    return res.json();
  }

  async addToCarts(variantId, quantity, selling_plan) {
    const body = {
      id: Number(variantId),
      quantity: quantity
    };
    if (selling_plan !== undefined) {
      body.selling_plan = selling_plan;
    }
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        // TODO: refresh cart drawer / mini-cart here if needed
        // Example with some themes:
        // document.dispatchEvent(new CustomEvent('cart:refresh'));
        console.log('Addon added', data);
      })
      .catch(function (err) {
        console.error('Error adding addon', err);
      });
  }

  async removeFromCart(variantId) {
    // update.js expects variantId keys as strings
    const updates = {};
    updates[variantId] = 0;
  
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        // TODO: refresh cart drawer / mini-cart
        console.log('Addon removed', data);
      })
      .catch(function (err) {
        console.error('Error removing addon', err);
      });
  
  }

  async syncToggleWithCart(toggle) {
    const variantId = Number(toggle.dataset.variantId);
    const key = toggle.dataset.storageKey || `nx_addon_${variantId}`;
  
    const cart = await this.getCart();
    const inCart = cart.items.some((item) => item.variant_id === variantId);
  
    toggle.checked = inCart;
    localStorage.setItem(key, inCart ? '1' : '0');
  }
  
  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
